export enum PARTNER_STATUS {
  ACTIVE = '101',
  INACTIVE = '111',
  REJECTED = '121'
};
